<header id="main-header">
    <div class="container">
        <div class="row">

            <div class="col-lg-3 col-7 my-auto">
                <a [routerLink]="['/home']">
                    <img src="/assets/images/sorteo2026/logo.png" alt="Sorteo Anáhuac 2026" class="logo img-fluid"
                        width="260">
                </a>
            </div>

            <div class="col-lg-9 col-5 my-auto ">
                <div class="mobile-nav-trigger">
                    <div class="hamburger hamburger--squeeze">
                        <div class="hamburger-box">
                            <div class="hamburger-inner"></div>
                        </div>
                    </div>
                </div>
                <nav class="main-nav d-xl-block d-none" style="margin-top: 10px;">
                    <ul class="site-navigation ">

                        <!-- <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Sorteos <i class="fa fa-caret-down"></i>
                            </a>
                            <div class="dropdown-menu p-3 custom-dropdown" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item" href="{{ urlMicrositioAniv }}" target="_blank">
                                    <img src="/assets/images/sorteo2025/logo-aniversario-171x58.png" alt="">
                                </a>
                                <a class="dropdown-item" href="{{urlMicrositio}}" target="_blank">
                                    <img src="/assets/images/sorteo2025/logo-menu-vf.png" width="171">
                                </a>
                            </div>
                        </li> -->



                        <!--                    
                        <li>
                            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/formulario-registro-colaboradores']"> Colabora
                            </a>
                        </li> -->


                        <li>
                            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                routerLink="/premios-sorteo-anahuac"> Premios
                            </a>
                        </li>




                        <!-- <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Premios <i class="fa fa-caret-down"></i>
                            </a>
                            <div class="dropdown-menu p-3 custom-dropdown" aria-labelledby="navbarDropdown">
                               Premios Sorteo Magno
                                </a> 
                                 <a class="dropdown-item" routerLink="/premios-sorteo-anahuac-aniversario">
                                    <img src="/assets/images/sorteo2025/logo-aniversario-171x58.png" alt="">
                                </a> 

                                <a class="dropdown-item" routerLink="/premios-sorteo-anahuac">
                                    <img src="/assets/images/sorteo2025/logo-menu-vf.png" alt="" width="171">
                                </a>
                            </div>
                        </li> -->


                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Compra tus boletos <i class="fa fa-ticket"></i>
                            </a>
                            <div class="dropdown-menu p-3" aria-labelledby="navbarDropdown">



                                <a class="dropdown-item" href="{{urlMicrositio}}" target="_blank">
                                    <img src="/assets/images/sorteo2025/logo-menu-vf.png" alt="" width="171">
                                </a>
                            </div>
                        </li>

                        <!-- <li>
                            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/lista-ganadores-sorteo-magno-2025']">
                                Lista de ganadores
                            </a>
                        </li>

                        <li>
                            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/login-ganadores']" class="last-child ">
                                Recoge tu premio
                            </a>
                        </li> -->




                        <!-- <li><a routerLink="/ganadores-sorteo-magno-novena-edicion" target="_blank">Lista de ganadores</a></li>
                        <li>
                            <a class="last-child latido-egr" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/galeria']">
                                Galería de ganadores
                            </a>
                        </li> -->
                        <!-- <li class="drop">
                            <div class="dropdown show">
                                <a class=" dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Sorteos
                                </a>
                              
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                     <div class="container-btn btn1 text-center">
                                        <a class="dropdown-item d-inline" [routerLink]="['/sorteo-egresado-universidad-anahuac']">
                                            <span class="blk">
                                                SORTEO DE EGRESADOS
                                            </span>
                                             <div class="number-count">
                                                <span>{{ dias_egr }}</span>.<span>{{ horas_egr }}</span>.<span>{{ minutos_egr }}</span>:<span>{{ segundos_egr }}</span>
                                            </div>
                                            <div class="labels text-center">
                                                <span>Días </span>
                                                <span>Hrs </span>
                                                <span>Min </span>
                                                <span>Seg </span>
                                            </div>
                                        </a>
                                       
                                    </div> 

                                     <div class="container-btn btn2 text-center">
                                        <a class="dropdown-item d-inline" [routerLink]="['/sorteo-oportuno']">
                                            <span class="blk">
                                                SORTEOS OPORTUNOS
                                            </span>
                                             <div class="number-count">
                                                <span>{{ dias }}</span>.<span>{{ horas }}</span>.<span>{{ minutos }}</span>.<span>{{ segundos }}</span>
                                            </div>
                                            <div class="labels text-center">
                                                <span>Días </span>
                                                <span>Hrs </span>
                                                <span>Min </span>
                                                <span>Seg </span>
                                            </div>
                                        </a>
                                    </div> 

                                    <div class="container-btn btn3 text-center">
                                        <a class="dropdown-item d-inline" href="https://sorteoanahuaccompra.sorteoanahuac.mx/compra-en-linea-boletos-sorteo-anahuac{{utmUrl}}" target="_blank">
                                            <span class="blk">
                                                SORTEO MAGNO
                                            </span>
                                             <div class="number-count">
                                                <span>{{ day }}</span>.<span>{{ hours }}</span>.<span>{{ minutes }}</span>.<span>{{ seconds }}</span>
                                            </div>
                                            <div class="labels text-center">
                                                <span>Días </span>
                                                <span>Hrs </span>
                                                <span>Min </span>
                                                <span>Seg </span>
                                            </div>
                                        </a>
                                    </div>
                                
                                </div>
                              </div>
                        </li>  -->
                        <li>
                            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/contacto']">
                                Contacto
                            </a>
                        </li>


                        <!-- <li>
                            <a class="last-child latido-egr" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                [routerLink]="['/sorteo-egresado-universidad-anahuac']">
                                Egresados
                            </a>
                        </li> -->
                    </ul>
                </nav>


            </div>


        </div>
    </div>


    <!-- <section class="sub-menu full-logo">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-between">


                <div class="col-md-12 text-center">

                    <a href="{{urlMicrositio}}" target="_blank">
                        <img src="/assets/images/sorteo2025/logo-magno-2.png" alt="Sorteo premios-aniversario"
                            class="img-fluid ml-4" style="margin: 13px 0 ;">
                    </a>


                </div>

            </div>
        </div>
    </section>

    <section class=" full-logo-egresados">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-between">


                <div class="col-md-12 text-center">


                    <img src="/assets/images/sorteo2025/egresados/logo-egresados.png" alt="Sorteo premios-aniversario"
                        class="img-fluid ml-4" style="margin: 13px 0 ;">



                </div>

            </div>
        </div>
    </section> -->



</header>

<section class="sub-menu ">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-between">



            <div class="col-md-12 text-center mx-auto">

                <div class="hero-container">
                    <nav class="apple-glass-bar d-flex justify-content-between align-items-center">

                        <div class="glass-section text-left">
                            <!-- <a href="/inicio" class="glass-btn d-inline-flex align-items-center">
                                <i class="fas fa-caret-left mr-2"></i>
                                <span class="font-weight-bold">Inicio</span>
                            </a> -->
                        </div>

                        <div class="glass-section text-center border-left border-right">
                            <a href="/home" class="glass-btn d-inline-block">
                                <img src="assets/images/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac" height="35"
                                    class="glass-logo-blanco">
                                <!-- Version negra: solo se ve en los slides de fondo
                                     blanco del home (.slide-fondo-claro, _header.scss) -->
                                <img src="assets/images/sorteo2026/ganadores-tercer/logo-tercer-negro.png"
                                    alt="Sorteo Anáhuac" height="35" class="glass-logo-negro">
                            </a>
                        </div>

                        <div class="glass-section text-right">
                            <a routerLink="/login-wallet"
                                class="glass-btn d-inline-flex align-items-center justify-content-end">
                                <i class="far fa-user-circle mr-2" style="font-size: 25px;"></i>
                                <span class="font-weight-bold">Mi Wallet</span>
                            </a>
                        </div>

                    </nav>
                </div>



            </div>
        </div>
    </div>
</section>



<nav class="hidden-menu mobile-menu">
    <ul class="mobile-nav">
        <span class="close d-block d-md-none" (click)="close();">×</span>
        <h3 class="p-0 m-0">
            MENÚ
        </h3>
        <hr class="line p-0 ">

        <!-- <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-sorteo-especial-2026']" class="main-nav-link">
                Participantes Rumbo a tu 1er Auto</a>
        </li>

        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/ganador-sorteo-especial-2026']" class="main-nav-link">
                Ganador Rumbo a tu 1er Auto</a>
        </li>

        <!-- <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-sorteo-egresados-2026']" class="main-nav-link">
                Participantes Sorteo Egresados </a>
        </li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-segundo-sorteo-oportuno-2026']" class="main-nav-link">Participantes
                2do Sorteo Oportuno</a></li>

         <li class="mb-2"><a  class="main-nav-link" routerLink="/lista-ganadores-sorteo-egresados-2026"
                target="_blank">Lista de ganadores Egresados 2026</a></li>

         <li class="mb-2"><a class="main-nav-link" routerLink="/lista-ganadores-segundo-sorteo-oportuno-2026"
                target="_blank">Lista de ganadores Segundo Sorteo Oportuno 2026</a></li> -->
        <!-- <li class="mb-2"><a class="last-child latido-egr " routerLink="/ganadores-sorteo-magno-novena-edicion"
                target="_blank">Lista de ganadores</a></li>
        <li>
            <a class="last-child latido-egr" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/galeria']">
                Galería de ganadores
            </a>
        </li> -->

        <!-- <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-ganadores-tercer-sorteo-oportuno-2025']" class="main-nav-link">
                Ganadores Tercer Sorteo oportuno </a>
        </li>
        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-ganadores-sorteo-anahuac-egresados-2025']" class="main-nav-link">
                Ganadores Sorteo Egresados </a>
        </li>

        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-terccer-sorteo-oportuno-2025']" class="main-nav-link">
                Participantes Tercer Sorteo oportuno </a>
        </li>


        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-sorteo-anahuac-egresados-2025']" class="main-nav-link">
                Participantes Sorteo Egresados 2025 </a>
        </li>

        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-ganadores-sorteo-aniversario']" class="main-nav-link">Ganadores
                Sorteo Aniversario</a>
        </li> -->



        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-primer-sorteo-oportuno-2025']" class="main-nav-link">Participantes
                1er Sorteo Oportuno</a></li> -->

        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-ganadores-primer-sorteo-oportuno-2025']" class="main-nav-link">Ganadores
                1er Sorteo Oportuno</a></li> -->

        <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" href="https://gana.sorteoanahuac.mx/"
                target="_blank" class="main-nav-link">Blog</a>
        </li>
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/formulario-registro-colaboradores']" class="main-nav-link">Colabora</a></li> -->
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/contacto']"
                class="main-nav-link">Contacto</a></li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/remanentes']"
                class="main-nav-link">Destino de fondos</a></li>
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                    [routerLink]="['/sorteo-egresado-universidad-anahuac']"
                    class="main-nav-link ">Egresados</a></li> -->
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/fechas-importantes']" class="main-nav-link">Fechas importantes</a></li> -->
        <!--

       -->

        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/galeria']"
                class="main-nav-link">Galería</a></li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/ganadores-sorteo']"
                class="main-nav-link">Ganadores Sorteos</a></li>

        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/venta-meses-sin-intereses']" class="main-nav-link">Meses sin intereses</a></li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/nosotros']"
                class="main-nav-link">Nosotros</a></li>
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/venta-meses-sin-intereses']" class="main-nav-link">Meses Sin Intereses</a></li> -->
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/preguntas-frecuentes']" class="main-nav-link">Preguntas frecuentes</a></li>

        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/puntos-de-venta']"
                class="main-nav-link">Puntos de venta</a></li>

        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/premios-sorteo-anahuac']" class="main-nav-link">Premios Sorteo Magno</a></li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/premios-para-colaboradores']" class="main-nav-link">Premios colaborador Sorteo
                Magno</a>
        </li>
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/premios-sorteo-anahuac-aniversario']" class="main-nav-link">Premios Sorteo Aniversario
            </a>
        </li> -->



        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/sorteo-oportuno']"
                class="main-nav-link">Sorteos oportunos</a></li>


        <!-- 
         <li>
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-segundo-sorteo-oportuno-2026']" class="main-nav-link">
                Participantes Segundo Sorteo oportuno </a>
        </li> -->

        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/login-wallet']"
                class="main-nav-link">Inicio de sesión</a></li>

        <!-- 3er Sorteo Oportuno 2026 -->
        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-participantes-tercer-sorteo-oportuno-2026']" class="main-nav-link">Participantes
                3er Sorteo Oportuno</a></li>
        <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/lista-ganadores-tercer-sorteo-oportuno-2026']" class="main-nav-link">Ganadores
                3er Sorteo Oportuno</a></li> -->

        <!-- <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [routerLink]="['/sorteo-egresado-universidad-anahuac']" class="main-nav-link">Egresados</a></li> -->



        <!-- 
        <ng-container *ngIf="!this.session">
            <li>
                <a data-toggle="modal" class="main-nav-link" data-target="#loginmodal">Inicia Sesión</a>
            </li>
        </ng-container>
        <ng-container *ngIf="this.session">
            <li><a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [routerLink]="['/menu-login']"
                    class="main-nav-link login">{{ this.nameSession }}</a></li>
        </ng-container> -->
    </ul>
</nav>


<div class="overlay" (click)="close();">

</div>


<div class="modal  " id="loginmodal" tabindex="-1" role="dialog" aria-labelledby="loginmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content border-gradient-all">

            <ng-container *ngIf="login; else recoveryEmail">
                <div class="modal-header d-block">
                    <h3 class="text-center text-login mx-auto">Inicia Sesión</h3>
                </div>
                <div class="modal-body text-center no-padding ">
                    <form #dataLogin="ngForm" novalidate (ngSubmit)="validateLogin(dataLogin)" autocomplete="off">
                        <div class="form-group">
                            <input autocomplete="correo" (input)="inputValidateEmail($event)" type="email"
                                class="form-control" id="correo" placeholder="Correo Electrónico" #correo="ngModel"
                                ngModel correo name="correo" [(ngModel)]="formLogin.correo" required>
                            <div *ngIf="correo.invalid && dataLogin.submitted " class="alert alert-danger">
                                Dato requerido
                            </div>
                        </div>
                        <div class="form-group">
                            <input autocomplete="pass" type="password" class="form-control" id="pass"
                                placeholder="Contraseña" #pass="ngModel" ngModel pass name="pass"
                                [(ngModel)]="formLogin.pass" required>
                            <div *ngIf="pass.invalid && dataLogin.submitted " class="alert alert-danger">
                                Dato requerido
                            </div>
                            <div *ngIf="passInval " class="alert alert-danger">
                                Datos incorrectos
                            </div>
                        </div>
                        <button type="submit" class="btn-modal">Enviar</button>

                        <a (click)="recoveryEm();">
                            <p class="text-center mt-4">
                                <span>¿Olvidaste tu contraseña?</span>
                            </p>
                        </a>
                    </form>

                </div>
            </ng-container>

            <ng-template #recoveryEmail>
                <div class="modal-header d-block">
                    <h3 class="text-center text-login">
                        Recupera tu contraseña
                    </h3>
                </div>
                <div class="modal-body text-center no-padding">

                    <form #dataMail="ngForm" novalidate (ngSubmit)="validateData(dataMail)">
                        <p class="mb-3 pb-3">Por favor, ingresa tu correo electrónico de registro para restablecer tu
                            contraseña.</p>
                        <div class="form-group">
                            <input autocomplete="new-email" (input)="inputValidateEmail($event)" type="email"
                                class="form-control" id="pkcolab" placeholder="Correo Electrónico" #pkcolab="ngModel"
                                ngModel pkcolab name="pkcolab" [(ngModel)]="formEmail.pkcolab" required>
                            <div *ngIf="successMail" class="alert alert-success">
                                Se ha enviado un correo para restablecer tu contraseña.
                            </div>
                            <div *ngIf="failMail" class="alert alert-danger">
                                El correo no existe, favor de verificar.
                            </div>
                            <div *ngIf="!formEmail.pkcolab || !valid_email " class="alert alert-danger">
                                Formato incorrecto
                            </div>

                        </div>
                        <button type="submit" class="btn-modal ">Enviar</button>
                        <a (click)="emailP();">
                            <p class="text-center mt-4">
                                <span>Regresar a inicio de sesión</span>
                            </p>
                        </a>
                    </form>

                </div>
            </ng-template>

        </div>
    </div>
</div>